import Axios from "axios";
import React, { Component, PureComponent } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
    useRouteMatch,
} from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import Func from "../../../functions";

const styles = {
    openAppBtn: {
        background: "rgb(0, 87, 228)",
        fontSize: "18px",
        color: "rgb(255, 255, 255)",
        marginBottom: "20px",
        width: "60%",
        marginBottom: "20px",
      },
};

class ButtonSlot extends PureComponent {
    constructor(props) {
        super(props);
    }

    handleClick = () => {
        if (this.props.callback) {
            this.props.callback(); // 執行傳入的 callback
        }
    };

    doRender = () => {
        const openAppBtnStyle = {
            ...styles.openAppBtn,
            background: this.props.color || styles.openAppBtn.background, 
        };

        return (
            <button className="btn btn-primary rounded-pill d-block mx-auto py-2" 
                    style={openAppBtnStyle}  
                    onClick={this.handleClick} >
                        {this.props.text}
            </button>
        );
    };

    render() {
        return (
            <div>
                {this.doRender()}
            </div>
        );
    }
}

export default hoistStatics(withTranslation()(ButtonSlot), ButtonSlot);
